import React from 'react'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI.js'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import AccountPropertyListSF from '../../../components/superUser/account//util/AccountPropertyListSF'

const EligibleEnterprise2xUI = ({ context, account, onRefreshClick
}) =>
  <SuperUserAccountPageUI context={context} className='pg_su_txns' backLink='/su/accounts'
    headerText={`${account ? account.accountName : ''}`}
    centered={!account} account={account} page='eligible2x'
  >
    {
      (!account) &&
      <SpinnerComponentUI />
    }
    {
      account &&
      <div>
        <LRTableActionsUI location='top'
          left={
            <span className='g_flex_left g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} label='Refresh' />
              <span className='g_m_left_100 g_large'><b>2X Eligible Enterprise</b></span>
            </span>
          }
          right={<span />}
        />

        <AccountPropertyListSF context={context} account={account}
          category='enterprise_2x' categoryLabel='2X Eligible Enterprise' />
      </div>
    }
  </SuperUserAccountPageUI>

export default EligibleEnterprise2xUI
